var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterials({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3889 11.25H18.3333V15L17.1111 14.168L15.8889 15V11.25H12.8333C12.4972 11.25 12.2222 11.5312 12.2222 11.875V19.375C12.2222 19.7187 12.4972 20 12.8333 20H21.3889C21.725 20 22 19.7187 22 19.375V11.875C22 11.5312 21.725 11.25 21.3889 11.25ZM6.72222 8.75H15.2778C15.6139 8.75 15.8889 8.46875 15.8889 8.12501V0.625012C15.8889 0.28125 15.6139 0 15.2778 0H12.2222V3.75L11 2.91797L9.77778 3.75V0H6.72222C6.38611 0 6.11111 0.28125 6.11111 0.625012V8.12501C6.11111 8.46875 6.38611 8.75 6.72222 8.75ZM9.16667 11.25H6.11111V15L4.88889 14.168L3.66667 15V11.25H0.611111C0.275 11.25 0 11.5312 0 11.875V19.375C0 19.7187 0.275 20 0.611111 20H9.16667C9.50278 20 9.77778 19.7187 9.77778 19.375V11.875C9.77778 11.5312 9.50278 11.25 9.16667 11.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterials);
export default __webpack_public_path__ + "static/media/Materials.516eb348644ebf7eb98b20b08e86b788.svg";
export { ForwardRef as ReactComponent };